import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'nw-logo-loading',
    templateUrl: './logo-loading.component.html',
    styleUrls: ['./logo-loading.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoLoadingComponent {
    @Input() color?: string;
}
